/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import format from 'material/chart/linechart/format'
// library
import { ResponsiveLine } from '@nivo/line'; // https://nivo.rocks/line/



/* ========== ~~~~~~~~~~ CHART : LINE : DETAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const DetailLineChart = (props) => {
    //ensuring that we have data, then binding dateLength to the length of dates,
    // Nivo will dynamically split anything under 9 x ticks and spread them between 9 ticks, causing double instances of x ticks
    const dateLength = !!props.data[0] ? props.data[0].data.length : null;

    return (
        <ResponsiveLine
            data={props.data}
            margin={{
                "top": 5,
                "right": 35,
                "bottom": 45,
                "left": 80
            }}
            xScale={{type: 'time',format: '%Y-%m-%d',precision: 'day'}}
            yScale={{
                "type": "linear",
                "stacked": false,
                "min": "auto",
                "max": "auto"
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                "orient": "bottom",
                "tickSize": 5,
                "tickPadding": 15,
                "tickRotation": 0,
                "legend": "",
                "legendOffset": 36,
                "legendPosition": "middle",
                "format": '%b %d',
                "tickValues": dateLength <= 9 ? dateLength : null
            }}
            axisLeft={{
                "orient": "left",
                "tickSize": 5,
                "tickPadding": 15,
                "tickRotation": 0,
                "legend": "",
                "legendOffset": -40,
                "legendPosition": "middle",
                "format": value => format(value, props.metricType) }
            }
            tooltipFormat={value => format(value, props.metricType)}
            enableGridX={false}
            enableGridY={false}
            colors="set2"
            lineWidth={3}
            dotSize={7}
            dotColor="#ffffff"
            dotBorderWidth={2}
            dotLabel="y"
            dotLabelYOffset={-12}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[]}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default DetailLineChart;